export const tariffUrl = '/cp/tariff';
export const licenseUrl = '/cp/licence';
